import { getParameterByName } from '@qdabra/forms-shared/urlHelpers';
import { failure } from '../helpers/commandResult';
import { getParamValue } from '../helpers/parameter.accessors';
import { paramKey } from "../constants/parameterNames";

const requiredParameters = {
    [paramKey]: {
        description: 'Name of Parameter for Desired Value',
    },
};

const description = "Returns if the key exists and gets the value back. If the key does not exist, FAIL is returned.";

const execute = ({ parameters }) => {
    const key = getParamValue(parameters, paramKey);

    const value = getParameterByName(key);

    if (!value) {
        return failure(`The requested key ${key} was not specified in the input parameters`);
    }

    return value;
};

const GetInputParameter = {
    description,
    execute,
    requiredParameters,
};

export default GetInputParameter;